import Gateway from './gateway';
import { GatewayResponse } from '~types/gateway';

import { TUpdateBranchStatusAPIParams, TUpdateInventoryTransactionStatusAPIParams, TUpdateInventoryTransferStatusAPIParams, TUpdateProjectStatusAPIParams, TUpdateReleaseEarmarkAPIParams, TUpdateTransactionStatusAPIParams } from '~types/feat/approval';

export abstract class IApprovalGateway extends Gateway {
    abstract updateTransactionStatus(params: TUpdateTransactionStatusAPIParams): GatewayResponse<null>;

    abstract updateInventoryTransactionStatus(params: TUpdateInventoryTransactionStatusAPIParams): GatewayResponse<null>;

    abstract updateProjectStatus(params: TUpdateProjectStatusAPIParams): GatewayResponse<null>;

    abstract updateInventoryTransferStatus(params: TUpdateInventoryTransferStatusAPIParams): GatewayResponse<null>;

    abstract updateReleaseEarmark(params: TUpdateReleaseEarmarkAPIParams): GatewayResponse<null>;

    abstract updateBranchStatus(params: TUpdateBranchStatusAPIParams): GatewayResponse<null>;
}
